export type WizardStep =
  | "step-messages"
  | "step-appointments"
  | "step-transfers"
  | "step-connect"

// IMP-461: the reduced guide — the assistant builds the agent from the
// business profile first (building beat), then three consequence-framed
// decisions and the phone/test/launch step. Voice is account-level (IMP-456,
// picked in onboarding) and free-text guidance lives in the edit drawer's
// Customization tab, so neither is a setup step anymore.
export const STEP_ORDER: WizardStep[] = [
  "step-messages",
  "step-appointments",
  "step-transfers",
  "step-connect",
]

export const STEP_TITLE: Record<WizardStep, string> = {
  "step-messages": "Messages",
  "step-appointments": "Appointments",
  "step-transfers": "Call transfers",
  "step-connect": "Test and go live",
}

// Legacy keys from the pre-IMP-461 wizard resume at the nearest survivor.
//
// IMP-492: the messages step is back. IMP-490 removed it, but the intended fix
// was to keep the control and make "off" mean the agent actively declines.
// Anyone who resumed at step-appointments in the meantime simply sees the
// messages step again — it's the first step, and the setting defaults to on.
const LEGACY_STEP_MAP: Record<string, WizardStep> = {
  "step-voice": "step-messages",
  "step-customization": "step-connect",
}

export function stepFor(raw: string | null | undefined): WizardStep {
  if (STEP_ORDER.includes(raw as WizardStep)) return raw as WizardStep
  return LEGACY_STEP_MAP[raw ?? ""] ?? "step-messages"
}
